import useGameStageContext from './useGameStageContext.hook';
import { StyledGameStageContext } from './GameStageContext.styled';
import { createContext, useRef } from 'react';

export const GameStageContext = createContext(null);

export function GameStageContextProvider({
  width = '100%',
  height = '100%',
  scaleAxis = 'x', // Used if maintainObjectsAspectRatio is true, to determine which axis to use as reference for the game objects sizes (in %)
  children,
  debug,
}) {
  const stageRef = useRef(null);
  const { state, actions } = useGameStageContext({
    width,
    height,
    scaleAxis,
    stageRef,
  });

  return (
    <StyledGameStageContext width={width} height={height} ref={stageRef}>
      <GameStageContext.Provider value={{ state, actions }}>
        {children}
      </GameStageContext.Provider>
      {debug && (
        <div className="grid">
          <div className="horizontal-grid">
            <div className="grid-box"></div>
            <div className="grid-box"></div>
            <div className="grid-box"></div>
            <div className="grid-box"></div>
            <div className="grid-box"></div>
            <div className="grid-box"></div>
            <div className="grid-box"></div>
            <div className="grid-box"></div>
            <div className="grid-box"></div>
            <div className="grid-box"></div>
          </div>
          <div className="vertical-grid">
            <div className="grid-box"></div>
            <div className="grid-box"></div>
            <div className="grid-box"></div>
            <div className="grid-box"></div>
            <div className="grid-box"></div>
            <div className="grid-box"></div>
            <div className="grid-box"></div>
            <div className="grid-box"></div>
            <div className="grid-box"></div>
            <div className="grid-box"></div>
          </div>
        </div>
      )}
    </StyledGameStageContext>
  );
}
